import RecruitmentFamilies from './recruitment-families';

export default RecruitmentFamilies;
